import {
  ORDER_REPORT_API_STATISTICAL,
  ORDER_REPORT_API_TYPE,
} from "./../../shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { GetOrderReportChartModel, OrderReportChartModel, OrderTotalReportModel } from "./order-report.models";

export const orderReportType = async (getOrderReportChartModel: GetOrderReportChartModel
) => {
  const createResponse = await apiClient.postHttp<OrderReportChartModel[]>(
    `${ORDER_REPORT_API_TYPE}`,
    getOrderReportChartModel
  );
  return createResponse;
};

export const getStatisticalOverview = async (branchId: number) => {
  return await apiClient.getHttp<OrderTotalReportModel>(`${ORDER_REPORT_API_STATISTICAL}`, {
    params:{
       branchId
    }
  });
};

